import { render, staticRenderFns } from "./OnboardingRedirectToMobile.vue?vue&type=template&id=fc00fb90&scoped=true"
import script from "./OnboardingRedirectToMobile.vue?vue&type=script&lang=js"
export * from "./OnboardingRedirectToMobile.vue?vue&type=script&lang=js"
import style0 from "./OnboardingRedirectToMobile.vue?vue&type=style&index=0&id=fc00fb90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc00fb90",
  null
  
)

export default component.exports